import React from 'react'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import { MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit'
import PageHeading from './../../components/shared/PageHeading.component'
import CreateEliteAgencyTeamButton from './components/CreateEliteAgencyTeamButton/CreateEliteAgencyTeamButton.component'
import Store from './store'
import EliteAgencyTeamList from './components/EliteAgencyTeamList/EliteAgencyTeamList.component'

import './EliteAgencyTeamsPage.scss'

class EliteAgencyTeamsPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isFetching: false,
    }
  }

  componentDidMount() {
    Store.fetch()
  }

  componentWillUnmount() {
    Store.end()
  }

  render() {
    return (
      <DashboardLayout>
        <main id='EliteAgencyTeamsPage' className='mainSection pb-5'>
          <MDBContainer fluid className='mt-5'>
            <PageHeading
              label='Elite Agency Teams'
              url={this.props?.match?.url}
              from={this.props?.location?.state?.from}
              btnGroup={<CreateEliteAgencyTeamButton />}
            />
          </MDBContainer>
          <EliteAgencyTeamList />
        </main>
      </DashboardLayout>
    )
  }
}

export default EliteAgencyTeamsPage
